import { GetExtranetNewslettersQueryDto } from '@pharmac-extranet/extranet-api'
import { cleanQueryParams } from '../../features/infinite-query/util/cleanQueryParams'

export const mapNewsletterSearchParams = (
  searchParams: URLSearchParams
): GetExtranetNewslettersQueryDto => {
  const stringArrayToNumberOrEmptyArray = (param: unknown): number[] => {
    if (Array.isArray(param)) return param.map(Number)

    return []
  }

  return cleanQueryParams({
    search: searchParams.get('search') ?? '',
    categoryIds: stringArrayToNumberOrEmptyArray(searchParams.getAll('categoryIds')),
  })
}
